"use client";

import { useState, useEffect, type InputHTMLAttributes } from "react";
import { cn } from "@retailos/core";

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onSearch: (value: string) => void;
  debounceMs?: number;
}

export function SearchInput({ onSearch, debounceMs = 300, className, ...props }: SearchInputProps) {
  const [value, setValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(value);
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [value, debounceMs, onSearch]);

  return (
    <div className="relative">
      <svg
        className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-text-dim"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={cn(
          "w-full rounded-xl border border-surface-border bg-surface pl-11 pr-4 py-3 text-base text-white placeholder:text-text-dim",
          "transition-all duration-200",
          "focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-surface-border-2",
          className,
        )}
        {...props}
      />
    </div>
  );
}
